import { RefObject, useLayoutEffect } from "react";

/**
 * El cuadro de escribir crece con el texto como WhatsApp (Esteban, 2026-10-12): hasta ~6 renglones y de ahí se desplaza
 * por dentro. Igual en computadora y en teléfono; lo usan WappChat, WappTeam y su ventanita.
 */
export const useCrecer = (ref: RefObject<HTMLTextAreaElement>, valor: string, renglones = 6): void => {
	useLayoutEffect(() => {
		const t = ref.current;
		if (!t) return;
		t.style.height = "auto";
		const cs = window.getComputedStyle(t);
		const lh = parseFloat(cs.lineHeight) || (parseFloat(cs.fontSize) || 14) * 1.35;
		const pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
		const tope = parseFloat(cs.maxHeight);
		const max = Math.min(Math.round(lh * renglones + pad), Number.isFinite(tope) && tope > 0 ? tope : Infinity);
		t.style.height = Math.min(t.scrollHeight, max) + "px";
		t.style.overflowY = t.scrollHeight > max + 1 ? "auto" : "hidden";
	}, [ref, valor, renglones]);
};
